import {useEffect, React, useState, useCallback, useMemo} from "react";
import SinglePortfolioViewSelect from "components/SinglePortfolioViewSelect/SinglePortfolioViewSelect"
import { useTranslation } from 'react-i18next';

// Stories
import { PageHeader, PageContainer } from "components/Page"

import { Col, Container, Row, Card, CardBody, CardHeader } from "stories/layout"

import {Link, Breadcrumb, BreadcrumbItem, Button, BreadcrumbsDynamic, Spinner} from 'stories/components';
import { useAuthContext } from "contexts/AuthContext";
import usePermissions from "hooks/usePermissions";
import { useStoreState, useStoreActions } from 'easy-peasy';
import { httpGetAllPortfoliosSummary} from "services/transactions"
import { round, thousandFormat } from "services/helpers"


import PortfoliosSummaryChart from "views/app/PortfoliosSummaryChart/PortfoliosSummaryChart"
import PortfoliosSummaryTableLineChart from "views/app/PortfoliosSummaryChart/PortfoliosSummaryTableLineChart" 
import PortfolioCarousel from "views/app/PortfolioCarousel/PortfolioCarousel"




// App
import graph01 from "assets/images/graph_01.jpg"
import graph02 from "assets/images/graph_02.jpg"
import { Typography } from "stories/components";

import UnmadeSplitTransactionsList from 'views/app/UnmadeSplitTransactionsList/UnmadeSplitTransactionsList'
import { set } from "date-fns";
import PortfolioSummaryCard from 'components/PortfolioSummaryCard/PortfolioSummaryCard';
import PortfoliosSummaryHero from "components/PortfoliosSummaryHero/PortfoliosSummaryHero";
import { isPortfoliosSummaryEmpty } from "utils/portfolioSummaryAggregate";
import './Frontpage.css';



const FrontPage = (props) => {



  const { t } = useTranslation();
  const { accountUserType } = useAuthContext();
  const { canWrite } = usePermissions();
  const account = useStoreState((state) => state.account?.account);

  const language = useStoreState((state) => state.language?.language);
  const unmadeSplitTransactions = useStoreState((state) => state.unmadeSplitTransactions?.unmadeSplitTransactions);
  const unmadeSplitTransactionsLoading = useStoreState((state) => state.unmadeSplitTransactions?.loading);
  const getUnmadeSplitTransactions = useStoreActions((actions) => actions.unmadeSplitTransactions.getUnmadeSplitTransactions);
  const unmadeDividendTransactions = useStoreState((state) => state.unmadeDividendTransactions?.unmadeDividendTransactions);
  const unmadeDividendTransactionsLoading = useStoreState((state) => state.unmadeDividendTransactions?.loading);
  const getUnmadeDividendTransactions = useStoreActions((actions) => actions.unmadeDividendTransactions.getUnmadeDividendTransactions);

  const portfolios = useStoreState((state) => state.portfolio?.portfolios);
  const portfoliosSummary = useStoreState((state) => state.portfoliosSummary?.portfoliosSummary);
  const portfoliosSummaryLoading = useStoreState((state) => state.portfoliosSummary?.loading);
  const portfoliosLoading = useStoreState((state) => state.portfolio?.loading);
  const portfolio = useStoreState((state) => state.portfolio?.portfolio);
  const getPortfoliosSummary = useStoreActions((actions) => actions.portfoliosSummary.getPortfoliosSummary);
  
  const [portfolioSummary, setProfitSummary] = useState()
  const [chartDataLoading, setChartDataLoading] = useState()

  const [portfolioName, setPortfolioName] = useState("")
  /** Pylväskaavion kortin karuselli — ohjaus CardHeaderissa */
  const [barChartCarouselIndex, setBarChartCarouselIndex] = useState(0)
  const [sumProfit, setSumProfit] = useState("-")
  const [allPortfoliosWAC, setAllPortfoliosWAC] = useState(false)
  const [chartData, setChartData] = useState({})

  
  function getFirstDayXMonthsAgo(months) {
    const date = new Date();
    
    // Vähennä 6 kuukautta nykyisestä kuukaudesta
    date.setMonth(date.getMonth() - months);
  
    // Aseta päivä kuukauden ensimmäiseksi päiväksi
    date.setDate(1);
  
    return date.toISOString().split('T')[0];
  }

  const barChartPortfolioKeys = useMemo(() => {
    if (isPortfoliosSummaryEmpty(portfoliosSummary)) return [];
    return Object.keys(portfoliosSummary);
  }, [portfoliosSummary]);

  const barChartPortfolioCount = barChartPortfolioKeys.length;

  const barChartNext = useCallback(() => {
    if (barChartPortfolioCount <= 1) return;
    setBarChartCarouselIndex((i) =>
      i === barChartPortfolioCount - 1 ? 0 : i + 1
    );
  }, [barChartPortfolioCount]);

  const barChartPrev = useCallback(() => {
    if (barChartPortfolioCount <= 1) return;
    setBarChartCarouselIndex((i) =>
      i === 0 ? barChartPortfolioCount - 1 : i - 1
    );
  }, [barChartPortfolioCount]);

  useEffect(() => {
    setBarChartCarouselIndex((i) =>
      barChartPortfolioCount === 0 ? 0 : Math.min(i, barChartPortfolioCount - 1)
    );
  }, [barChartPortfolioCount]);

  useEffect(() => {
    // getUnmadeSplitTransactions()
    // getUnmadeDividendTransactions()
    getPortfoliosSummary()
    }, [])

  useEffect(() => {
    if (portfolios && portfolios.length > 0){
      //check is all portfolios sell_profit_calculation_method is FIFO
      const isFIFO = portfolios.every(portfolio => portfolio.sell_profit_calculation_method === "WAC")
      setAllPortfoliosWAC(isFIFO)
    }
  }, [portfolios])



  //get crumb links from location state or return default links
  const getCrumbLinks = () => {
    const crumbLinks = [
      {
        name: t("Etusivu"),
          url: "/dashboard",  
        },
    ]
    //if location state include crumbLinks return them
    if (props.location?.state && props.location?.state?.crumbLinks) {
      props.location.state.crumbLinks.push({name: t("Etusivu"), url: "/dashboard"})
      return props.location.state.crumbLinks
    }
    //else return default links
    return crumbLinks
  }

  const getPortfoliosData = () => {
    const params = {
      // portfolio: filters?.portfolio,
      // date_transaction__date__gte: filters?.date_transaction__date__gte ? moment(filters?.date_transaction__date__gte).format("YYYY-MM-DD") : undefined,
      // sdate_transaction__date__lte: filters?.date_transaction__date__lte ? moment(filters?.date_transaction__date__lte).format("YYYY-MM-DD") : undefined,
      // stock_market: filters?.stock_market ? filters?.stock_market : undefined,
      // selected_portfolios: null,
      ordering:  "-date_transaction",
    }
    setChartDataLoading(true)
    httpGetAllPortfoliosSummary(params).then(response => {
        // setProfitSummary(response?.data)

        if (response?.data){
          setProfitSummary(response?.data?.portfolios_market_value)
          let options=  []
          const sellOptions = response?.data?.sell || []
          const buyOptions = response?.data?.buy || []
          const optionsSet = new Set()
          // setSecurityOptions(options)
        }
        // console.log(response?.data)
        // setLoading(false)
      }, error => {
        setChartDataLoading(false)
        console.log(error)
      })
      .finally(() => {
        setChartDataLoading(false)
      }
      )

  }

  useEffect(() => {
    // getPortfoliosData()
  }, [portfoliosLoading])

  const getChart = useCallback(() => {
    if (isPortfoliosSummaryEmpty(portfoliosSummary)) return (
      <Container fluid className="d-flex justify-content-center align-items-center">
      <Spinner className="mt-3" />
    </Container>
    )

    const portfolios = Object.keys(portfoliosSummary).map((portfolioId) => ({
      id: portfolioId,
      src: 'data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22800%22%20height%3D%22400%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20800%20400%22%20preserveAspectRatio%3D%22none%22%3E%3Cdefs%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%23holder_15ba800aa1d%20text%20%7B%20fill%3A%23555%3Bfont-weight%3Anormal%3Bfont-family%3AHelvetica%2C%20monospace%3Bfont-size%3A40pt%20%7D%20%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22holder_15ba800aa1d%22%3E%3Crect%20width%3D%22800%22%20height%3D%22400%22%20fill%3D%22%23777%22%3E%3C%2Frect%3E%3Cg%3E%3Ctext%20x%3D%22285.921875%22%20y%3D%22218.3%22%3EFirst%20slide%3C%2Ftext%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E',

      ...portfoliosSummary[portfolioId]
    }));

    return (
      <div>
        <PortfolioCarousel
          portfolios={portfolios}
          setPortfolioName={setPortfolioName}
          activeIndex={barChartCarouselIndex}
          onActiveIndexChange={setBarChartCarouselIndex}
          hideOverlayControls
        />
      </div>
    );
    return <PortfoliosSummaryChart data={portfoliosSummary}/>
   }, [portfoliosSummary, barChartCarouselIndex])


   const getTotal = useCallback(() => {
    if (isPortfoliosSummaryEmpty(portfoliosSummary)) return null
    const sumOfPortfolios = Object.values(portfoliosSummary).reduce((acc, portfolio) => {
      for (const [key, value] of Object.entries(portfolio)) {
        if (!acc.hasOwnProperty(key)) {
          acc[key] = 0;
        }
        acc[key] += value;
      }
      return acc;
    }, {});

    return (sumOfPortfolios)
    }, [portfoliosSummary])


    const get_portfolio_names = () => {
      let portfolios_filtered = portfolios.filter(o =>
        unmadeSplitTransactions.map(t => t.batch.portfolio).includes(o.id)
      );
    
      return portfolios_filtered.map(o => o?.name); // Just return the portfolio names
    };

    const portfolioNames = () => {
      const portfolioNames = get_portfolio_names(); // Get portfolio names
    
      return (
        <div  className="d-flex justify-content start align-items-center" >
          {portfolioNames.map((name, index) => (
            <>
            <i className="fas fa-circle fa-xs text-light" key={index} />
            <Typography variant="h4" className="ml-2 mr-4 text-light" key={index}>{name}</Typography>
            </>
          ))}
        </div>
      );
    };
 
   const getSum = useCallback(() => {
    if (isPortfoliosSummaryEmpty(portfoliosSummary)) return (
      <Container fluid className="d-flex justify-content-center align-items-center">
        <Spinner className="mt-3" />
      </Container>
    )



    const sumOfPortfolios = Object.values(portfoliosSummary).reduce((acc, portfolio) => {
      for (const [key, value] of Object.entries(portfolio)) {
        if (!acc.hasOwnProperty(key)) {
          acc[key] = 0;
        }
        acc[key] += value;
      }
      return acc;
    }, {});
    let summary =  JSON.parse(JSON.stringify(sumOfPortfolios));
    summary = {"summary": summary}
    // summary.summary.Hankintahinta *= -1
    // setSumProfit(summary.summary.Markkina_arvo)
    delete summary.summary.Realisoitumattomat_tuotot
    delete summary.summary.Realisoituneet_tuotot
    const profit_percentage = (summary.summary.Markkina_arvo - summary.summary.Hankintahinta) / summary.summary.Hankintahinta * 100 || 0.0
    let profit_classes = "text-bold text-success"
    let icon_profit_classes = "fas fa-arrow-up"
    if(summary.summary.Markkina_arvo < summary.summary.Hankintahinta){
      profit_classes = "text-bold text-danger"
      icon_profit_classes = "fas fa-arrow-down"
    }



    return (
      <Row>
        <Col xs="7">
          <div className="mx-2">
            <PortfoliosSummaryChart data={summary} width="100" height="80"/>
          </div>
        </Col>

          
        <Col xs="5">
        <Typography variant="h2" className="text-bolder mt-3">{t("frontpage_profit","Tuotto")}</Typography>
        <Typography variant="h2" bolder className="text-bold my-1">{sumOfPortfolios && sumOfPortfolios.Realisoitumattomat_tuotot ? thousandFormat(sumOfPortfolios.Realisoitumattomat_tuotot.toFixed(2)) : ""}€</Typography>
        <Typography variant="h1" className={profit_classes}>{profit_percentage ? profit_percentage.toFixed(2) : ""}%  <i className={icon_profit_classes}/></Typography>
        <Typography variant="h4" className="text-bold mt-3">{t("frontpage_realized","Realisoituneet")}: {sumOfPortfolios && sumOfPortfolios.Realisoituneet_tuotot ? thousandFormat(sumOfPortfolios.Realisoituneet_tuotot.toFixed(2)) : ""}€ </Typography>
        </Col>
      </Row>
    )
   }, [portfoliosSummary])
  
  return (
    <>
    <Row className="frontpage-container">
    {account?.show_frontpage_portfolio_summary && (
      <PortfoliosSummaryHero
        className="w-100"
        portfoliosSummary={portfoliosSummary}
        loading={portfoliosSummaryLoading}
        accountUserType={accountUserType}
        selectedPortfolioName={portfolio?.name}
        portfolioCount={portfolios?.length || 0}
        currencyLabel={portfolio?.currency_label || portfolios?.[0]?.currency_label}
      />
    )}
    {(account?.show_frontpage_portfolio_summary ) &&
      <Col xs="12" lg="6">
      <Card className="shadow-sm-strong h-100 frontpage-selected-portfolio-card">
          <CardHeader className="sk-frontpage-card-header frontpage-selected-portfolio-card__header d-flex justify-content-between align-items-start flex-wrap">
            <div className="d-flex align-items-center mr-2 mb-2 mb-md-0 flex-grow-1 min-w-0">
              <div className="sk-card-header-icon-box mr-3 flex-shrink-0" aria-hidden>
                <i className="fas fa-chart-bar text-muted" />
              </div>
              <div className="min-w-0">
                <div className="frontpage-selected-portfolio-card__eyebrow text-muted text-uppercase small font-weight-bold">
                  {t("front_page_selected_portfolio", "Valittu salkku")}
                </div>
                <Typography variant="h4" className="text-bold mb-0 text-truncate">
                  {portfolio?.name}
                </Typography>
              </div>
            </div>
            <div className="frontpage-selected-portfolio-card__value-block d-flex flex-column align-items-end text-right ml-md-auto">
              <span className="frontpage-selected-portfolio-card__currency text-muted small mb-0">
                {portfolio?.currency_label}
              </span>
              <Typography variant="h4" className="text-bold mb-0">
                <span className="mr-1">{t("all_portfolios_summary_profit", "")}</span>
                <span className="mr-1">{t("front_page_portfolio_value", "Arvo")}</span>
                {chartData?.latest_market_value ? thousandFormat(chartData?.latest_market_value.toFixed(2)) : ""}
              </Typography>
            </div>
            <SinglePortfolioViewSelect id="frontpage-selected-portfolio" className="w-100 mt-2" />
          </CardHeader>
          <CardBody className="frontpage-selected-portfolio-card__body pt-2">
  
          <Row className="mb-0">
            <Col className="frontpage-selected-portfolio-card__chart">
            {portfolio && (
              <PortfoliosSummaryTableLineChart
                portfolio={portfolio?.id}
                date__gte={getFirstDayXMonthsAgo(5)}
                setChartData={setChartData}
                currency={portfolio?.currency_label}
                themeHostSelector=".frontpage-selected-portfolio-card"
              />
            )}
            </Col>
          </Row>
          <Row className="frontpage-selected-portfolio-card__kpi mb-1 border-top">
            {/* <Col className="border-rigth">
                <div className="mt-2 ml-1">
                  <Typography variant="h4" className="text-bold">{t("frontpage_one_day","1vrk")}   <span style={{ fontSize: '0.8em', marginLeft: '0.2em' }}>({portfolio?.currency_label})</span></Typography>
              {
                (chartData?.latest_market_value || chartData?.latest_market_value==0)  && 
                  <Typography className={(chartData?.yesterday_change ||chartData?.yesterday_change ==0 )  && chartData?.yesterday_change >= 0 ? 'text-success' : 'text-danger' }> 
                    {(chartData?.yesterday_change ||chartData?.yesterday_change ==0 )  && chartData?.yesterday_change >= 0 ? "+" : ""}
                    {(chartData?.yesterday_change ||chartData?.yesterday_change ==0 )  ?thousandFormat(chartData?.yesterday_change.toFixed(2)):null}
                    </Typography>
              }
                </div>
            </Col> */}
            <Col className="frontpage-selected-portfolio-card__kpi-col">
                <div className="frontpage-selected-portfolio-card__kpi-inner mt-2">
                  <Typography variant="small" className="text-muted text-uppercase font-weight-bold mb-1 d-block">
                    {t("frontpage_one_month", "1kk")}{" "}
                    <span className="text-lowercase font-weight-normal">({portfolio?.currency_label})</span>
                  </Typography>
                  {(chartData?.latest_market_value || chartData?.latest_market_value === 0) && (
                  <Typography
                    variant="h4"
                    className={`text-bold mb-0 ${(chartData?.monthly_change || chartData?.monthly_change === 0) && chartData?.monthly_change >= 0 ? "text-success" : "text-danger"}`}
                  >
                    {(chartData?.monthly_change || chartData?.monthly_change === 0) && chartData?.monthly_change >= 0 ? "+" : ""}
                    {(chartData?.monthly_change || chartData?.monthly_change === 0) ? thousandFormat(chartData?.monthly_change.toFixed(2)) : null}
                  </Typography>
                  )}
                </div>
            </Col>
            <Col className="frontpage-selected-portfolio-card__kpi-col border-left">
                <div className="frontpage-selected-portfolio-card__kpi-inner mt-2">
                  <Typography variant="small" className="text-muted text-uppercase font-weight-bold mb-1 d-block">
                    {t("frontpage_one_year", "1v.")}{" "}
                    <span className="text-lowercase font-weight-normal">({portfolio?.currency_label})</span>
                  </Typography>
                  {(chartData?.latest_market_value || chartData?.latest_market_value === 0) && (
                  <Typography
                    variant="h4"
                    className={`text-bold mb-0 ${(chartData?.one_year_change || chartData?.one_year_change === 0) && chartData?.one_year_change >= 0 ? "text-success" : "text-danger"}`}
                  >
                    {(chartData?.one_year_change || chartData?.one_year_change === 0) && chartData?.one_year_change >= 0 ? "+" : ""}
                    {(chartData?.one_year_change || chartData?.one_year_change === 0) ? thousandFormat(chartData?.one_year_change.toFixed(2)) : null}
                  </Typography>
                  )}
                </div>
            </Col>
            <Col className="frontpage-selected-portfolio-card__kpi-col border-left">
                <div className="frontpage-selected-portfolio-card__kpi-inner mt-2">
                  <Typography variant="small" className="text-muted text-uppercase font-weight-bold mb-1 d-block">
                    {t("frontpage_ytd", "YTD")}{" "}
                    <span className="text-lowercase font-weight-normal">({portfolio?.currency_label})</span>
                  </Typography>
                  {(chartData?.latest_market_value || chartData?.latest_market_value === 0) && (
                  <Typography
                    variant="h4"
                    className={`text-bold mb-0 ${(chartData?.yearly_change || chartData?.yearly_change === 0) && chartData?.yearly_change >= 0 ? "text-success" : "text-danger"}`}
                  >
                    {(chartData?.yearly_change || chartData?.yearly_change === 0) && chartData?.yearly_change >= 0 ? "+" : ""}
                    {(chartData?.yearly_change || chartData?.yearly_change === 0) ? thousandFormat(chartData?.yearly_change.toFixed(2)) : null}
                  </Typography>
                  )}
                </div>
            </Col>
          </Row>
  
  
          </CardBody>
  
          </Card>
        </Col>
      }
      
      {/* New Portfolio Summary Card - moved here from bottom */}
      {(account?.show_frontpage_portfolio_summary ) &&
        <Col xs="12" lg="6" className="mt-3 mt-lg-0">
          <PortfolioSummaryCard portfoliosSummary={portfoliosSummary} />
        </Col>
      }
        {(!account?.show_frontpage_portfolio_summary && !allPortfoliosWAC && account?.show_front_page_portfolio_summary_bar_chart) &&
      <Col xs="12" lg="6" className="mt-3 mt-lg-0">
        <Card className={`shadow-sm-strong  h-100  `} style={{ backgroundColor: getTotal()?.Realisoitumattomat_tuotot < 0? ' rgb(223, 33, 33, 0.08)': 'rgba(69, 201, 21, 0.08)' }}>
          <CardHeader className="sk-frontpage-card-header d-flex justify-content-between align-items-center flex-wrap">
            <div className="d-flex align-items-center min-w-0 mr-2">
              <div className="sk-card-header-icon-box mr-3 flex-shrink-0" aria-hidden>
                <i className="fas fa-chart-pie text-muted" />
              </div>
              <Typography variant="h4" className="text-bold mb-0">
              {t("all_portfolios_summary", "Salkkujen tuotto")}
              </Typography>
            </div>
            <Typography variant="h4" className="text-bold mb-0 ml-md-auto flex-shrink-0">
              <span className="mr-1">{t("all_portfolios_summary_profit", "")}</span>
              <span className={getTotal()?.Realisoitumattomat_tuotot < 0 ? "text-danger" : "text-success"}>
                {getTotal()?.Realisoitumattomat_tuotot ? thousandFormat(getTotal()?.Realisoitumattomat_tuotot.toFixed(2)) : ""} €
              </span>
            </Typography>
          </CardHeader>
          <CardBody>
  
          <Row className="mb-5">
            <Col>
             {getSum()}
            </Col>
          </Row>
  
  
          </CardBody>
  
          </Card>
          </Col>
      }





        {(!allPortfoliosWAC && account?.show_front_page_portfolio_summary_bar_chart) &&
      <Col xs="12" lg="6" className="mt-4">

      <Card className="shadow-sm-strong h-100 frontpage-bar-chart-card">
        <CardHeader className="sk-frontpage-card-header d-flex justify-content-between align-items-center flex-wrap">
          <div className="d-flex align-items-center min-w-0 mr-2 flex-grow-1">
            <div className="sk-card-header-icon-box mr-2 flex-shrink-0" aria-hidden>
              <i className="fas fa-chart-area text-muted" />
            </div>
            <Typography variant="h4" className="text-bold mb-0 text-truncate">
              {portfolioName}
            </Typography>
          </div>
          <div className="d-flex align-items-center flex-shrink-0 flex-wrap justify-content-end">
            {barChartPortfolioCount > 1 && (
              <div className="d-flex align-items-center mr-3 mb-1 mb-md-0">
                <button
                  type="button"
                  className="btn btn-sm portfolio-summary-card__nav-btn mr-1"
                  onClick={barChartPrev}
                  aria-label={t("portfolio_carousel_previous", "Edellinen salkku")}
                >
                  <i className="fas fa-chevron-left" aria-hidden />
                </button>
                <span className="mx-2 small text-muted">
                  {barChartCarouselIndex + 1}/{barChartPortfolioCount}
                </span>
                <button
                  type="button"
                  className="btn btn-sm portfolio-summary-card__nav-btn"
                  onClick={barChartNext}
                  aria-label={t("portfolio_carousel_next", "Seuraava salkku")}
                >
                  <i className="fas fa-chevron-right" aria-hidden />
                </button>
              </div>
            )}
            <Typography variant="h4" className="text-bold mb-0">
              EUR
            </Typography>
          </div>
        </CardHeader>
        <CardBody >

        <Row>
          <Col>
           {getChart()}
          </Col>
        </Row>


        </CardBody>

        </Card>
        </Col>
      }
      


      {canWrite && (
      <Col xs="12" lg="6" className="mt-4">


              <Card className="shadow-sm-strong h-100">
              <CardHeader className="sk-frontpage-card-header d-flex align-items-center">
                <div className="sk-card-header-icon-box mr-3 flex-shrink-0" aria-hidden>
                  <i className="fas fa-random text-muted" />
                </div>
                <Typography variant="h4" className="text-bold mb-0">
                  {t("web_frontpage_process_splits", "Käsittele saapuneet splitit tai osingot")}
                </Typography>
              </CardHeader>
              <CardBody className="p-3">
              {(false) ?             
                <Container fluid className="d-flex justify-content-center align-items-center">
                  <Spinner className="mt-3" />
                </Container> :
              <>
              {  unmadeSplitTransactions?.[0]?.batch  ? (
                <>
                <Link to="/dashboard/transactions" >
                  
                    <div className="d-flex justify-content start align-items-center bg-white border p-2 rounded ">
                      <i className="fas fa-exclamation-triangle text-danger fa-1x mr-3" />
                      <div className="">
                          <div>
                            
                          <Typography  variant="p" className="text-dark">
                            {t("unmade_split_transactions_list_description",`Split-kirjauksia (${unmadeSplitTransactions?.length}) tekemättä. Tiedot eivät välttämättä näy oikein!`) }
                          </Typography>
                          </div>

                          {account.split_handling_only_active_portfolio == true && (
                        <>
                        {portfolioNames() }
                        </>

                      )
                      }
                        
                      </div>   
                    </div>
                   
            
                </Link>
                </>
              ):(
                <div className="d-flex justify-content-start align-items-center bg-white border p-2 rounded">
                  {unmadeSplitTransactionsLoading ? (
                    <div className="mx-auto mb-1 ">
                      <Spinner className="mt-3" />
                    </div>
                  ):(
                    <>
                      <i className="fas fa-thumbs-up text-success fa-1x mr-3" />
                      <div className="d-flex align-items-center">
                        <Typography variant="p" className="text-dark">
                          {t("web_frontpage_splits_ok","Split-kirjaukset tehty!") }
                        </Typography>
                      </div>  
                    </>
                  )}
                </div>
              )
             }
             {
              account.hide_dividends_handling ? null :
              <>
                { unmadeDividendTransactions?.[0]?.batch ? (
                  <>
                  <Link to="/dashboard/transactions" >
                    <div className="d-flex justify-content start align-items-center mt-4 bg-white border p-2 rounded ">
                    <i className="fas fa-coins text-danger fa-1x mr-3" />
                    <div className="d-flex align-items-center">
                        <Typography variant="p" className="text-dark">
                          {t("unmade_dividend_transactions_list_description",`Osinko-kirjauksia (${unmadeDividendTransactions?.length}) tekemättä.`) }
                        </Typography>
                        </div>   
                    </div>
                  </Link>
                  </>
                ):(
                  <div className="d-flex justify-content-start align-items-center bg-white border mt-4 p-2 rounded">
                    {unmadeDividendTransactionsLoading? (
                      <div className="mx-auto mb-1 ">
                        <Spinner className="mt-3" />
                      </div>
                    ):(
                      <>
                        <i className="fas fa-thumbs-up text-success fa-2x mr-3" />
                        <div className="d-flex align-items-center">
                            <Typography variant="h3" className="text-dark">
                              {t("web_frontpage_dividends_ok","Osinko-kirjaukset tehty!") }
                            </Typography>
                        </div>   
                      </>
                    )}
                  </div>
                )
              }
              
              </>
             }
     
   
              </>
             }
  
             </CardBody>
  
             </Card>
  
  
        </Col>
      )}
        {/* <Col xs="12" md="6" className="mt-4">
          <Card className="shadow-sm-strong  h-100">
            <CardHeader className="text-bold d-flex justify-content-between align-items-center">
              {portfolioName}
              <span variant="h4" className="text-bold ml-auto">EUR</span>
            </CardHeader>
            <CardBody >

            <Row className="mb-5 ">
              <Col>
              {getChart()}
              </Col>
            </Row>


            </CardBody>

            </Card>
        </Col> */}
    </Row>

    {/* Palaute */}
    <Row className="mt-4">
      <Col xs="12">
        <Card className="shadow-sm-strong">
          <CardBody>
            <h3 className="mb-3">{t("frontpage_feedback","Kerro palautteesi")}</h3>
            <Link href="https://investime.fi/ota-yhteytta" target="_blank">
              <Button className="sk-quick-actions__btn" variant="secondary">{t('web_frontpage_send_us_feedback','Lähetä meille palautetta')}</Button>
            </Link>
          </CardBody>
        </Card>
      </Col>
    </Row>

{/*
    <Row>
        <Col className="mb-3">
          <img src={graph01} />
        </Col>
        <Col className="mb-3">
          <img src={graph02} />kmvkgbbb
        </Col>
  </Row>*/}
    </>
  );
}

export default FrontPage;
